(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product__smart-related"] && !Shopify.designMode) return;
  try {
    
  const handleIntersection = (entries, observer) => {
    if (!entries[0].isIntersecting) return;

    observer.unobserve(productRecommendationsSection);

    const url = productRecommendationsSection.dataset.url;

    fetch(url)
      .then(response => response.text())
      .then(text => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('.product-recommendations');

        if (recommendations && recommendations.innerHTML.trim().length) {
          productRecommendationsSection.innerHTML = recommendations.innerHTML;
          const swiperElement = productRecommendationsSection.querySelector('.js-product-recommendations-slider');
          const swiperParams = {
            spaceBetween:20,
            slidesPerView:1.5,
            loop:false,
            lazy: {
              loadPrevNext: true,
            },
            navigation: {
              nextEl: `.js-product-recommendations-slider__controls--next`,
              prevEl: `.js-product-recommendations-slider__controls--prev`,
            },
            breakpoints: {
              736:{
                slidesPerView:2,
              },
              1024:{
                slidesPerView:3,
              },
            }
          }
          const swiper = new Swiper(swiperElement,swiperParams)
        }else{
          productRecommendationsSection.remove()
        }
      })
      .catch(e => {
        console.error(e);
      });
  };

  const productRecommendationsSection = document.querySelector('.product-recommendations');
  const observer = new IntersectionObserver(handleIntersection, {rootMargin: '0px 0px 200px 0px'});

  observer.observe(productRecommendationsSection);


  } catch(e) { console.error(e); }
})();
})();
